import { gql } from "lib/apolloClient";
import { userProfileDetailsFragment } from "./ProfileFragments";

export const getUserProfileDetailsQuery = gql`
  query getUserProfileDetails($id: ID!, $type: ENTITY_TYPE_ENUM!) {
    node(id: $id, type: $type) {
      ... on Staff {
        ...staffProfileItem
      }
      ... on Student {
        ...studentProfileItem
      }
    }
  }
  ${userProfileDetailsFragment.staffProfileDetails}
  ${userProfileDetailsFragment.studentProfileDetails}
`;
